import * as React from 'react';
import {
    Box,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { ItemCreatRequest, ItemListResponse } from 'types/product/product-item';
import { useProductTitleListQuery } from 'store/slices/product/product-list';
import pxToRem from 'assets/theme/function/px-to-rem';

const getSubscribeList = [
    { label: '1 Month', value: 1 },
    { label: '2 Month', value: 2 },
    { label: '1 Years', value: 12 },
];

interface Props {
    control?: Control<ItemCreatRequest>;
    errors: FieldErrors<ItemCreatRequest>;
    data?: ItemListResponse;
}
const ItemSubscribe: React.FC<Props> = (props: Props) => {
    const { control, data, errors } = props;

    const initialSubscribePeriod = data?.itemValue?.period ?? '';
    const initialProductId = data?.itemValue.productId ?? '';

    const { data: dataProductTitle } = useProductTitleListQuery();

    return (
        <Box display={'flex'} alignItems={'center'}>
            <FormControl
                error={Boolean(errors?.itemValue?.period)}
                sx={{ width: '50%' }}
            >
                <InputLabel>Period</InputLabel>
                <Controller
                    name="itemValue.period"
                    control={control}
                    rules={{
                        required: 'Period is required',
                    }}
                    render={({ field }) => (
                        <Select
                            label="Period"
                            {...field}
                            value={
                                field.value ?? (initialSubscribePeriod || '')
                            }
                        >
                            {getSubscribeList?.map((category) => (
                                <MenuItem
                                    key={category.value.toString()}
                                    value={category.value}
                                >
                                    {category.label}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                />
                {errors?.itemValue?.period && (
                    <FormHelperText>
                        {errors?.itemValue?.period.message?.toString()}
                    </FormHelperText>
                )}
            </FormControl>

            <FormControl
                error={Boolean(errors?.itemValue?.productId)}
                sx={{ width: '50%', ml: pxToRem(10) }}
            >
                <InputLabel>Product Id</InputLabel>
                <Controller
                    name="itemValue.productId"
                    control={control}
                    rules={{
                        required: 'Product Id is required',
                    }}
                    render={({ field }) => (
                        <Select
                            label="Product Id"
                            {...field}
                            value={field.value ?? (initialProductId || '')}
                        >
                            {dataProductTitle?.map((category) => (
                                <MenuItem
                                    key={category.title.toString()}
                                    value={category.id}
                                >
                                    {category.title}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                />
                {errors?.itemValue?.productId && (
                    <FormHelperText>
                        {errors?.itemValue?.productId.message?.toString()}
                    </FormHelperText>
                )}
            </FormControl>
        </Box>
    );
};

export default ItemSubscribe;
